/*global embedded_svc*/
import { loaded } from "@/services/loader";
import { get } from "@/services/request";
import { currentUserAPI } from "@/services/api";
import envConfiguration from "@/services/envValues";

// the library contains the following script loading but it's not really needed and it causes issues, so comment it out
// loadJS(
//   "https://service.force.com/embeddedservice/5.0/esw.min.js",
//   "salesforce-chat-lib"
// );

// // library code
var initESW = function(gslbBaseURL, user) {
  embedded_svc.settings.displayHelpButton = true; //Or false
  embedded_svc.settings.language = "en"; //For example, enter 'en' or 'en-US'

  embedded_svc.settings.extraPrechatFormDetails = [
    {
      label: "Username",
      value: user.username != "Anonymous" ? user.username : "",
      displayToAgent: true
    },
    {
      label: "vpEmail",
      value: user.email,
      displayToAgent: true
    }
  ];

  embedded_svc.settings.extraPrechatInfo = [
    {
      entityFieldMaps: [
        {
          doCreate: true,
          doFind: true,
          fieldName: "Username",
          isExactMatch: true,
          label: "Username"
        },
        {
          doCreate: true,
          doFind: true,
          fieldName: "vpEmail",
          isExactMatch: true,
          label: "vpEmail"
        }
      ],
      entityName: "Contact"
    }
  ];

  //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
  //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

  embedded_svc.settings.enabledFeatures = ["LiveAgent"];
  embedded_svc.settings.entryFeature = "LiveAgent";

  embedded_svc.init(
    envConfiguration.salesforcePtUrl,
    envConfiguration.vpUrl,
    gslbBaseURL,
    envConfiguration.salesforceId,
    envConfiguration.salesforceChatGroup,
    {
      baseLiveAgentContentURL:
        envConfiguration.salesforceBaseLiveAgentContentUrl,
      deploymentId: envConfiguration.salesforceDeploymentId,
      buttonId: envConfiguration.salesforceChatBtn,
      baseLiveAgentURL: envConfiguration.salesforceLiveAgentUrl,
      eswLiveAgentDevName: envConfiguration.salesforceChatGroup,
      isOfflineSupportEnabled: true
    }
  );
};

loaded(() => {
  if (!window.embedded_svc) {
    var s = document.createElement("script");
    s.setAttribute("src", envConfiguration.salesforceEswUrl);
    //ensures that user info is available in pages outside of vue
    s.onload = function() {
      get(currentUserAPI).then(response => {
        initESW(null, response.data);
      });
    };
    document.body.appendChild(s);
  } else {
    initESW("https://service.force.com");
  }
});
